var _path, _path2, _g, _path3, _g2, _g3, _g4, _g5, _g6, _g7, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSelfDevelopment = function SvgSelfDevelopment(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 217,
    viewBox: "0 0 225 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 427318767"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Left-3",
    d: "M36.0039 181.32L51.8613 175.065C52.2614 174.905 52.3681 174.212 52.088 173.518L43.6992 152.246C43.4325 151.552 42.8857 151.126 42.4722 151.272L26.6149 157.527C26.028 157.754 26.1348 159.048 26.8016 159.741L34.2168 167.423C34.5636 167.783 34.8036 168.37 34.7903 168.877L34.6169 179.546C34.6036 180.506 35.4038 181.533 35.9906 181.293L36.0039 181.32Z",
    fill: "#4539FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Left-4",
    d: "M187.522 181.36L171.745 174.892C171.345 174.732 171.252 174.038 171.532 173.345L180.214 152.193C180.494 151.499 181.054 151.072 181.454 151.246L197.231 157.714C197.818 157.954 197.685 159.248 197.005 159.928L189.483 167.503C189.123 167.863 188.883 168.45 188.883 168.957L188.909 179.626C188.909 180.587 188.096 181.6 187.509 181.36H187.522Z",
    fill: "#4539FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_1241_128586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.515 26.4806L29.5889 80.9078C25.0277 84.2153 23.1205 90.0968 24.8677 95.4582L53.4883 183.534C55.2354 188.895 60.2233 192.523 65.8647 192.523H158.475C164.116 192.523 169.104 188.895 170.851 183.534L199.472 95.4582C201.219 90.0968 199.312 84.2287 194.751 80.9078L119.825 26.4806C115.264 23.1731 109.089 23.1731 104.528 26.4806H104.515Z",
    fill: "url(#paint0_linear_1241_128586)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M106.142 30.735L32.8297 84.0019C29.3755 86.5092 27.9351 90.9637 29.2555 95.0181L57.2626 181.2C58.5829 185.254 62.3706 188.015 66.6383 188.015H157.248C161.516 188.015 165.303 185.268 166.624 181.2L194.631 95.0181C195.951 90.9637 194.511 86.5092 191.057 84.0019L117.745 30.735C114.29 28.2277 109.609 28.2277 106.155 30.735H106.142Z",
    fill: "url(#paint1_linear_1241_128586)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Base-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1241_128586",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 28,
    width: 168,
    height: 161
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M106.368 30.735L33.0564 84.0019C29.6022 86.5092 28.1618 90.9637 29.4821 95.0181L57.4893 181.2C58.8096 185.254 62.5972 188.015 66.865 188.015H157.475C161.742 188.015 165.53 185.268 166.85 181.2L194.858 95.0181C196.178 90.9637 194.738 86.5092 191.283 84.0019L117.971 30.735C114.517 28.2277 109.836 28.2277 106.382 30.735H106.368Z",
    fill: "white"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1241_128586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M112.223 228.412C167.031 228.412 211.462 202.157 211.462 169.77C211.462 137.384 167.031 111.129 112.223 111.129C57.4153 111.129 12.9846 137.384 12.9846 169.77C12.9846 202.157 57.4153 228.412 112.223 228.412Z",
    fill: "#30AFD3"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Shine-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1241_128586",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 24,
    width: 177,
    height: 169
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M104.515 26.4806L29.5889 80.9078C25.0277 84.2153 23.1205 90.0968 24.8677 95.4582L53.4883 183.534C55.2354 188.895 60.2233 192.523 65.8647 192.523H158.475C164.116 192.523 169.104 188.895 170.851 183.534L199.472 95.4582C201.219 90.0968 199.312 84.2287 194.751 80.9078L119.825 26.4806C115.264 23.1731 109.089 23.1731 104.528 26.4806H104.515Z",
    fill: "white"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1241_128586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.15,
    d: "M5.06253 239.762C2.46187 232.506 1.15486 228.412 -1.4458 219.263C15.9853 206.326 34.7101 197.577 53.2481 186.561C72.8531 174.918 88.7639 159.701 106.075 144.991C141.911 114.57 168.291 109.208 213.609 121.385C216.21 123.719 217.517 124.919 220.117 127.52C173.919 113.876 147.859 124.706 112.583 155.714C78.2411 185.921 37.4041 207.873 5.04922 239.748L5.06253 239.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.15,
    d: "M-4.95327 223.597C-20.7973 195.51 -27.8391 162.409 -35.2277 131.427C12.1711 132.188 37.4842 108.421 72.3064 79.3741C107.849 49.7265 135.549 41.8712 179.84 56.5683C190.323 66.9843 200.379 77.2269 210.115 88.3497C164.05 66.4775 134.029 96.4184 102.581 128.573C68.5587 163.369 30.4291 190.722 -4.95327 223.597Z",
    fill: "white"
  })))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Stars-2",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M118.812 42.6714C119.423 42.6714 119.918 42.1758 119.918 41.5645C119.918 40.9531 119.423 40.4575 118.812 40.4575C118.2 40.4575 117.705 40.9531 117.705 41.5645C117.705 42.1758 118.2 42.6714 118.812 42.6714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M138.83 58.142C140.178 58.142 141.271 57.0493 141.271 55.7014C141.271 54.3535 140.178 53.2608 138.83 53.2608C137.482 53.2608 136.389 54.3535 136.389 55.7014C136.389 57.0493 137.482 58.142 138.83 58.142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M121.145 56.875C122.442 56.875 123.493 55.8241 123.493 54.5278C123.493 53.2314 122.442 52.1805 121.145 52.1805C119.849 52.1805 118.798 53.2314 118.798 54.5278C118.798 55.8241 119.849 56.875 121.145 56.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M56.0624 148.592C57.3587 148.592 58.4096 147.541 58.4096 146.244C58.4096 144.948 57.3587 143.897 56.0624 143.897C54.766 143.897 53.7151 144.948 53.7151 146.244C53.7151 147.541 54.766 148.592 56.0624 148.592Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M60.3834 161.688C61.7313 161.688 62.824 160.596 62.824 159.248C62.824 157.9 61.7313 156.807 60.3834 156.807C59.0355 156.807 57.9427 157.9 57.9427 159.248C57.9427 160.596 59.0355 161.688 60.3834 161.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M63.5575 141.843C64.1689 141.843 64.6645 141.348 64.6645 140.736C64.6645 140.125 64.1689 139.629 63.5575 139.629C62.9462 139.629 62.4506 140.125 62.4506 140.736C62.4506 141.348 62.9462 141.843 63.5575 141.843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M172.439 151.499L170.438 154.78C170.131 155.287 169.384 155.287 169.064 154.78L167.064 151.499C166.904 151.246 166.904 150.926 167.064 150.659L169.064 147.378C169.371 146.871 170.118 146.871 170.438 147.378L172.439 150.659C172.599 150.912 172.599 151.246 172.439 151.499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M164.196 136.429L162.623 139.003C162.383 139.403 161.796 139.403 161.542 139.003L159.969 136.429C159.849 136.229 159.849 135.975 159.969 135.775L161.542 133.201C161.783 132.801 162.369 132.801 162.623 133.201L164.196 135.775C164.316 135.975 164.316 136.229 164.196 136.429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M55.2888 79.9209L54.1151 81.828C53.9284 82.1215 53.5017 82.1215 53.3149 81.828L52.1546 79.9209C52.0613 79.7742 52.0613 79.5875 52.1546 79.4274L53.3149 77.5203C53.5017 77.2269 53.9284 77.2269 54.1151 77.5203L55.2888 79.4274C55.3821 79.5741 55.3821 79.7609 55.2888 79.9209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M66.5983 84.7755L64.331 88.4831C63.9709 89.0565 63.1307 89.0565 62.784 88.4831L60.5168 84.7755C60.3434 84.482 60.3434 84.122 60.5168 83.8285L62.784 80.1209C63.1441 79.5475 63.9843 79.5475 64.331 80.1209L66.5983 83.8285C66.7717 84.122 66.7717 84.482 66.5983 84.7755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M174.106 126.8L172.532 129.374C172.292 129.774 171.705 129.774 171.452 129.374L169.878 126.8C169.758 126.599 169.758 126.346 169.878 126.146L171.452 123.572C171.692 123.172 172.278 123.172 172.532 123.572L174.106 126.146C174.226 126.346 174.226 126.599 174.106 126.8Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Clock"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_19",
    filter: "url(#filter1_d_1241_128586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.13 155.407C138.188 155.407 158.502 135.093 158.502 110.035C158.502 84.9772 138.188 64.6637 113.13 64.6637C88.0721 64.6637 67.7585 84.9772 67.7585 110.035C67.7585 135.093 88.0721 155.407 113.13 155.407Z",
    fill: "#FFBC00"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M118.752 149.491C140.548 146.385 155.699 126.198 152.593 104.403C149.488 82.6067 129.301 67.4555 107.505 70.5614C85.7091 73.6673 70.558 93.8541 73.6639 115.65C76.7697 137.446 96.9565 152.597 118.752 149.491Z",
    fill: "#F28E2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M118.154 145.292C137.631 142.517 151.17 124.478 148.395 105.001C145.619 85.5239 127.58 71.9846 108.103 74.7601C88.6263 77.5355 75.0871 95.5747 77.8626 115.052C80.638 134.529 98.6771 148.068 118.154 145.292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M113.744 116.237C113.624 116.237 113.517 116.197 113.41 116.117L102.781 107.768C102.541 107.581 102.501 107.248 102.687 107.008C102.874 106.781 103.208 106.728 103.448 106.914L113.664 114.93L129.694 94.8847C129.881 94.658 130.214 94.618 130.455 94.8047C130.681 94.9914 130.721 95.3248 130.535 95.5649L114.17 116.023C114.064 116.157 113.904 116.223 113.744 116.223V116.237Z",
    fill: "#582B34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M110.583 86.5226C110.396 86.5226 110.249 86.3892 110.223 86.2025L109.449 79.014C109.423 78.8139 109.569 78.6406 109.769 78.6139C109.969 78.5872 110.143 78.7339 110.169 78.934L110.943 86.1225C110.97 86.3225 110.823 86.4959 110.623 86.5226C110.623 86.5226 110.596 86.5226 110.583 86.5226Z",
    fill: "#582B34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M116.544 142.203C116.357 142.203 116.211 142.07 116.184 141.883L115.411 134.695C115.384 134.495 115.531 134.321 115.731 134.295C115.931 134.281 116.104 134.415 116.131 134.615L116.904 141.803C116.931 142.003 116.784 142.177 116.584 142.203C116.584 142.203 116.558 142.203 116.544 142.203Z",
    fill: "#582B34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M137.43 108.181C137.243 108.181 137.096 108.048 137.07 107.861C137.043 107.661 137.19 107.488 137.39 107.461L144.578 106.688C144.778 106.674 144.952 106.808 144.978 107.008C145.005 107.208 144.858 107.381 144.658 107.408L137.47 108.181C137.47 108.181 137.443 108.181 137.43 108.181Z",
    fill: "#582B34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M81.7354 114.143C81.5487 114.143 81.402 114.01 81.3753 113.823C81.3487 113.623 81.4954 113.449 81.6954 113.423L88.8839 112.649C89.084 112.623 89.2573 112.769 89.284 112.969C89.3107 113.169 89.164 113.343 88.9639 113.369L81.7755 114.143C81.7755 114.143 81.7488 114.143 81.7354 114.143Z",
    fill: "#582B34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    opacity: 0.35,
    d: "M67.9586 105.594C68.2654 96.3117 77.5877 68.4246 108.316 64.9304C108.316 64.9304 82.7224 68.4913 67.9586 105.594Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M171.932 184.481C131.108 170.931 94.7388 171.197 54.1151 185.361C51.9012 186.268 49.514 185.708 48.7804 184.041C45.633 176.946 44.0593 173.398 40.9251 166.316C40.1783 164.649 41.6586 162.355 44.2326 161.302C90.5511 144.577 134.096 144.137 180.761 159.928C183.361 160.942 184.868 163.195 184.162 164.876C181.428 172.171 180.054 175.812 177.253 183.094C176.533 184.774 174.172 185.374 171.945 184.494L171.932 184.481Z",
    fill: "#4539FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M55.0487 174.625C54.5819 174.572 54.1685 174.398 53.8217 174.105C53.4749 173.825 53.2082 173.438 53.0482 172.931L54.902 172.384C55.0087 172.664 55.1687 172.851 55.3688 172.958C55.5688 173.065 55.7956 173.078 56.049 172.998C56.3023 172.918 56.489 172.798 56.6091 172.624C56.7291 172.451 56.7425 172.251 56.6758 172.024C56.6224 171.838 56.5158 171.691 56.3557 171.611C56.1957 171.531 56.0223 171.464 55.8222 171.438C55.6222 171.411 55.3554 171.384 55.0087 171.384C54.5019 171.371 54.0751 171.331 53.7417 171.264C53.4083 171.197 53.0882 171.051 52.7948 170.811C52.5014 170.571 52.2747 170.211 52.1413 169.744C51.9279 169.037 52.0079 168.41 52.3813 167.863C52.7548 167.316 53.3149 166.93 54.0884 166.703C54.8753 166.476 55.5688 166.49 56.169 166.756C56.7691 167.023 57.1959 167.503 57.436 168.21L55.5555 168.757C55.4755 168.517 55.3288 168.343 55.1287 168.25C54.9287 168.157 54.7153 168.143 54.4619 168.21C54.2485 168.277 54.1018 168.383 54.0084 168.543C53.9151 168.703 53.9017 168.89 53.9684 169.117C54.0351 169.37 54.2085 169.53 54.4619 169.597C54.7153 169.664 55.102 169.717 55.6088 169.744C56.1156 169.77 56.5424 169.824 56.8758 169.89C57.2092 169.957 57.5293 170.104 57.8227 170.331C58.1161 170.557 58.3295 170.904 58.4629 171.358C58.5963 171.798 58.5963 172.224 58.5029 172.638C58.3962 173.051 58.1828 173.425 57.8494 173.745C57.516 174.065 57.0759 174.305 56.5424 174.465C56.0223 174.612 55.5288 174.665 55.062 174.598L55.0487 174.625Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M61.0636 166.53L61.4637 168.09L63.8242 167.49L64.1844 168.944L61.8237 169.544L62.2505 171.237L64.9179 170.557L65.3046 172.064L60.8768 173.185L58.9297 165.463L63.3575 164.342L63.7442 165.849L61.0769 166.53H61.0636Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M68.5988 169.77L70.9194 169.25L71.2395 170.717L67.1451 171.624L65.4247 163.849L67.1984 163.462L68.5988 169.77Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M76.0541 161.675L76.3475 163.195L73.3601 163.769L73.6802 165.423L75.9074 164.996L76.1875 166.476L73.9602 166.903L74.5737 170.064L72.7866 170.411L71.2795 162.595L76.0408 161.675H76.0541Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M82.9491 163.742L83.2025 165.329L78.588 166.076L78.3346 164.489L82.9491 163.742Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M92.9384 159.781C93.5652 160.048 94.0587 160.461 94.4454 161.022C94.8322 161.582 95.0723 162.248 95.1523 163.035C95.2323 163.809 95.1523 164.516 94.8989 165.156C94.6455 165.796 94.2454 166.303 93.6986 166.703C93.1518 167.103 92.4849 167.343 91.7114 167.423L88.9374 167.73L88.0571 159.821L90.8312 159.514C91.618 159.421 92.3116 159.514 92.9384 159.781ZM92.9384 164.996C93.2718 164.556 93.4052 163.969 93.3252 163.249C93.2451 162.515 92.9917 161.968 92.5649 161.608C92.1382 161.248 91.5914 161.102 90.8979 161.182L90.0443 161.275L90.5644 165.876L91.418 165.783C92.0981 165.703 92.6049 165.449 92.9517 165.009L92.9384 164.996Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M98.6464 160.315L98.7665 161.915L101.194 161.728L101.314 163.222L98.8865 163.409L99.0199 165.156L101.767 164.943L101.887 166.49L97.3394 166.836L96.726 158.901L101.274 158.554L101.394 160.101L98.6464 160.315Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M110.409 158.114L108.102 166.169L105.835 166.263L102.861 158.421L104.795 158.341L106.889 164.262L108.489 158.181L110.409 158.101V158.114Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M113.984 159.648V161.262L116.424 161.248V162.742L113.997 162.755V164.502L116.758 164.489V166.049L112.197 166.076L112.156 158.114L116.718 158.087V159.635L113.97 159.648H113.984Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M120.505 164.609L122.879 164.662L122.839 166.156L118.638 166.049L118.838 158.087L120.652 158.127L120.492 164.582L120.505 164.609Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M126.04 165.876C125.48 165.489 125.04 164.983 124.747 164.329C124.44 163.689 124.32 162.969 124.36 162.195C124.413 161.422 124.626 160.728 125.013 160.141C125.4 159.554 125.893 159.088 126.494 158.781C127.094 158.474 127.747 158.341 128.454 158.381C129.148 158.421 129.788 158.634 130.348 159.021C130.908 159.408 131.335 159.915 131.628 160.555C131.922 161.195 132.042 161.902 132.002 162.675C131.948 163.449 131.735 164.142 131.362 164.742C130.988 165.343 130.495 165.796 129.894 166.103C129.294 166.41 128.641 166.543 127.947 166.503C127.24 166.463 126.614 166.249 126.053 165.863L126.04 165.876ZM129.508 164.209C129.894 163.809 130.108 163.262 130.148 162.569C130.188 161.862 130.055 161.302 129.721 160.848C129.388 160.395 128.934 160.168 128.334 160.128C127.734 160.088 127.24 160.261 126.854 160.661C126.467 161.062 126.254 161.608 126.214 162.315C126.174 163.022 126.307 163.595 126.64 164.036C126.974 164.476 127.441 164.716 128.041 164.756C128.641 164.796 129.121 164.609 129.508 164.209Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M139.203 163.315C138.963 163.676 138.63 163.942 138.19 164.142C137.75 164.342 137.243 164.396 136.629 164.329L135.509 164.209L135.202 167.05L133.402 166.85L134.256 158.941L137.176 159.261C137.763 159.328 138.257 159.488 138.643 159.755C139.03 160.021 139.297 160.355 139.47 160.755C139.644 161.155 139.684 161.608 139.63 162.102C139.577 162.555 139.444 162.969 139.203 163.329V163.315ZM137.47 162.595C137.656 162.435 137.763 162.209 137.803 161.888C137.843 161.568 137.776 161.315 137.63 161.128C137.483 160.942 137.23 160.822 136.883 160.781L135.896 160.675L135.683 162.662L136.669 162.769C137.016 162.809 137.283 162.742 137.47 162.595Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M150.246 161.102L149.006 168.957L147.219 168.677L147.966 163.956L145.578 168.41L144.125 168.183L143.218 163.195L142.471 167.917L140.67 167.637L141.911 159.781L144.031 160.115L145.245 165.889L148.152 160.768L150.259 161.102H150.246Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M154.034 163.462L153.7 165.036L156.088 165.529L155.781 166.996L153.394 166.503L153.034 168.21L155.728 168.77L155.408 170.291L150.94 169.357L152.567 161.568L157.035 162.502L156.715 164.022L154.02 163.462H154.034Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M163.703 172.344L161.943 171.891L160.222 166.383L159.009 171.144L157.248 170.691L159.222 162.982L160.982 163.435L162.703 168.97L163.93 164.196L165.69 164.649L163.716 172.358L163.703 172.344Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M173.105 166.89L172.652 168.37L170.758 167.783L168.878 173.905L167.144 173.371L169.024 167.25L167.13 166.663L167.584 165.183L173.092 166.876L173.105 166.89Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1241_128586",
    x: 0.220697,
    y: -0.00610924,
    width: 223.898,
    height: 216.535,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.0031
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_128586"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1241_128586",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1241_128586",
    x: 67.7585,
    y: 64.6637,
    width: 92.6637,
    height: 92.6636,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.92049,
    dy: 1.92049
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_128586"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1241_128586",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1241_128586",
    x1: 112.503,
    y1: 276.931,
    x2: 112.17,
    y2: 101.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#25B2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D6F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1241_128586",
    x1: 111.343,
    y1: -32.8812,
    x2: 112.13,
    y2: 133.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6B72FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#4495F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#26B1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#11C5F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#04D1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D6F0"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSelfDevelopment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "self-development.3fc23e3.svg";